var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ClockCircle",
    clipPath: "url(#clip0_97_1713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C10.7464 0.5 0 11.2464 0 24.5C0 37.7536 10.7464 48.5 24 48.5C37.2536 48.5 48 37.7536 48 24.5C48 11.2464 37.2536 0.5 24 0.5ZM24 44.4286C12.9964 44.4286 4.07143 35.5036 4.07143 24.5C4.07143 13.4964 12.9964 4.57143 24 4.57143C35.0036 4.57143 43.9286 13.4964 43.9286 24.5C43.9286 35.5036 35.0036 44.4286 24 44.4286Z",
    fill: "#546B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3593 31.2771L25.7201 25.7539V12.495C25.7201 12.2593 25.5272 12.0664 25.2915 12.0664H22.7147C22.479 12.0664 22.2861 12.2593 22.2861 12.495V27.2486C22.2861 27.3878 22.3504 27.5164 22.4629 27.5968L31.3236 34.0575C31.5165 34.1968 31.7843 34.1539 31.9236 33.9664L33.4558 31.8771C33.5951 31.6789 33.5522 31.411 33.3593 31.2771Z",
    fill: "#546B84"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_1713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3b3dd91f443d8b7c78e7c91a4a48806f.svg";
export { ForwardRef as ReactComponent };